import { render, staticRenderFns } from "./Ntvr.vue?vue&type=template&id=3df67027&"
import script from "./Ntvr.vue?vue&type=script&lang=js&"
export * from "./Ntvr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Ntvr.vue"
export default component.exports